import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import toast from "react-hot-toast";

//Serivce
import ItemService from "../../../../services/supplier_appCommonService";
import { useDispatch } from "react-redux";
import { validateRequired } from "../../../../common/Validations";
import { useNavigate } from "react-router-dom";
import CustomerConstants from "../../../../common/CustomerConstants";
import { initializeAppData } from "../../../../AppDataUtils";

const EmployeeLoginModal = React.forwardRef((props, ref) => {
  const message = {
    VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
    VALID_MAIL_ID: "Please enter a valid email address.",
    VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
    VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
    VALID_ALTERNATE_CONTACT_NUMBER:
      "Please enter a valid alternate contact number.",
    VALID_PURPOSE_JUSTIFICATION:
      "Please ensure the justification is under 500 characters.",
    VALID_POSTAL_CODE:
      "Enter a 6-character postal code with uppercase letters and numbers only",
    VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
    VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
    EXIStS_MAIL_ID: "Email already exists",
    EXIStS_CONTACT_NUMBER: "Contact Number already exists",
    EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
    EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
    FILL_REQUIRED_FIELD: "Please fill the required field",
    ALTERNATE_MAIL_ID: "Email ID is same",
    ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [getdisable, setDisabled] = useState(false);
  const [formInputs, setFormInputs] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const [getUser, setUser] = useState({});
  //   console.log(">>getUser",getUser)
  useEffect(() => {
    setUser(props.user);
  }, [props.user]);

  const handleLogin = async () => {
    let requiredFields = [];
    const anyFieldNotEmpty = Object.values(validation).some(
      (value) => value !== null && value !== ""
    );
    if (anyFieldNotEmpty) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      return;
    }
    if (!validateRequired(formInputs.password)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setValidation((prev) => ({
        ...prev,
        password: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    let obj = {
      email: getUser?.id,
      password: formInputs?.password,
    };

    setDisabled(true);
    ItemService.login(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "User registered successfully", {
          duration: 2000,
          position: "top-right",
        });
        initializeAppData(dispatch, "ALL");
        navigate(CustomerConstants.HOME_INTRO);
        window.location.reload();

        //  if (item?.data?.defaultAppCode === "ALL") {
        //    window.location = ConstantsList.APP_HOME;
        //  } else if (item?.data?.defaultAppCode === "CUSTOMER") {
        //    window.location = CustomerConstantsList.HOME_INTRO;
        //  } else {
        //    window.location = ConstantsList.HOME_INTRO;
        //  }
      } else {
        setValidation((prev) => ({
          ...prev,
          password: item?.message || "Invalid credentials",
        }));
        toast.error(item?.message || "Invalid input", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
    toast.dismiss("");
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);
  const [validation, setValidation] = useState({});

  const handleInputChange = (e) => {
    const errors = {};
    const { name, value } = e.target;

    setFormInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };
  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="md"
      ref={ref}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {/* <i className="bi bi-plus-lg"></i>  */}
          Employe Login
          {/* <p className="subText">
            At supplier_app, every person has a role, each with its own level of
            access.
          </p> */}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        <div className="d-flex justify-content-center align-items-center">
          <Row>
            <Col xs={12} md={12} lg={12} className="ms-3">
              <p>
                Please enter the password for user{" "}
                <span className="fw-bold">{getUser.description}</span> to login
              </p>
            </Col>
            <Col xs={12} md={12} lg={12} className="commLeftRightPadding">
              <div className="w-full">
                {/* Input + Eye button wrapper */}
                <div className="relative">
                  <input
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    value={formInputs?.password || ""}
                    onChange={handleInputChange}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleLogin(); // ✅ trigger login on Enter
                      }
                    }}
                    placeholder="Enter Password"
                    className="w-full rounded-lg px-3 py-2 pr-10 text-sm focus:outline-none focus:ring-2"
                    style={{
                      border: validation.password
                        ? "1px solid #ef4444" // red border
                        : "1px solid #d1d5db", // gray border
                      outline: "none",
                    }}
                  />

                  {/* Eye Toggle Button inside input */}
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label="Toggle password visibility"
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  >
                    {showPassword ? (
                      <i className="bi bi-eye-fill"></i>
                    ) : (
                      <i className="bi bi-eye-slash-fill"></i>
                    )}
                  </button>
                </div>

                {/* Validation Message */}
                {validation.password && (
                  <p className="mt-1 text-sm text-red-500">
                    {validation.password}
                  </p>
                )}
              </div>
            </Col>
          </Row>
        </div>
        <div className="space-y-4">
          <Row className="justify-end">
            <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
              <button
                onClick={() => props.onHide()}
                className="btn btn-danger mt-4 justify-center w-full rounded-md"
              >
                Cancel
              </button>
            </Col>
            <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
              <button
                type="button"
                onClick={handleLogin}
                className="btn btn-primary mt-4 w-full justify-center rounded-md"
                disabled={getdisable}
              >
                Login
              </button>
            </Col>
            <Col xs={12} md={12} lg={12} className="commLeftRightPadding">
              {/* <p className="errorMsg"> {errorMsg} </p> */}
            </Col>
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
});

export default EmployeeLoginModal;
